// Reusable function to fetch and display text content
async function fetchAndDisplayText(fileUrl, setContent) {
    try {
      const response = await fetch(fileUrl);
      if (response.ok) {
        const data = await response.text();
        setContent(data);
      } else {
        console.error(`Failed to fetch ${fileUrl}`);
      }
    } catch (error) {
      console.error(`Error loading ${fileUrl}:`, error);
    }
  }
  
export { fetchAndDisplayText }